import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface CategoryCardProps {
  title: string;
  icon: LucideIcon;
  category: string;
  description: string;
  onClick: () => void;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({
  title,
  icon: Icon,
  description,
  onClick
}) => {
  return (
    <div
      onClick={onClick}
      className="group bg-white/90 backdrop-blur-sm p-8 rounded-3xl shadow-lg hover:shadow-xl 
        transition-all duration-500 cursor-pointer hover:-translate-y-2 border border-gray-100
        hover:border-orange-200"
    >
      <div className="bg-gradient-to-br from-orange-100 to-pink-100 rounded-2xl p-4 w-16 h-16 
        flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <Icon className="w-8 h-8 text-orange-500" />
      </div>
      <h3 className="text-2xl font-semibold mb-4">{title}</h3>
      <p className="text-gray-600 mb-6">{description}</p>
      <div className="text-orange-500 font-medium flex items-center gap-2 group-hover:gap-3 transition-all duration-300">
        Explore Now <ChevronRight className="w-4 h-4" />
      </div>
    </div>
  );
}; 